export default "<div class=\"outlet-wrapper\">\r\n  Settings Page Coming Soon!\r\n</div>\r\n"